import {
  jb_arrow_forward_icon_css_default
} from "./chunk.EY4AYOWG.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-arrow-forward-icon/jb-arrow-forward-icon.ts
var JbArrowForwardIcon = class extends r {
  render() {
    return ke`
      <svg
        viewbox="0 0 11 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.01 7.72L.66 1.38l.7-.71 7.08 7.07-.71.7-6.62 6.62-.71-.71 6.61-6.62z"
          fill-rule="evenodd"
        ></path>
      </svg>
    `;
  }
};
JbArrowForwardIcon.styles = [reset_css_default, jb_arrow_forward_icon_css_default];
JbArrowForwardIcon = __decorateClass([
  customElement("jb-arrow-forward-icon")
], JbArrowForwardIcon);

export {
  JbArrowForwardIcon
};
